import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as dayjs from 'dayjs';
import { forkJoin, of, Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ALL_HOLIDAY_TYPES } from '../../booking-flow/holiday/holiday-search-page/helpers/holiday-types';
import { LoadingItem } from '../../shared/interfaces/loading-item';
import { BookingService } from '../../shared/services/booking.service';
import { HolidayPrefetchService } from '../../shared/services/holiday-prefetch.service';
import { LoadingService } from '../../shared/services/loading.service';
import { SEOService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-proposte',
  templateUrl: './proposte.component.html',
  styleUrls: ['./proposte.component.scss']
})
export class ProposteComponent implements OnInit, OnDestroy {

  prefetchSubscription: Subscription;

  constructor(private _holidayPrefetchService: HolidayPrefetchService,
              private _seoService: SEOService,
              private _loadingService: LoadingService,
              private _bookingService: BookingService,
              private _router: Router) {
  }

  ngOnInit(): void {
    this._seoService.setTitle('Le Nostre Proposte');
    const loadingItem: LoadingItem = {id: 'tour-redirect', message: 'Caricamento pagina in corso...'};
    this._loadingService.addLoad(loadingItem);
    this.prefetchSubscription = this._holidayPrefetchService.prefetchDestinations({
      onlyCustomHoliday: true,
      ages: this._bookingService.getAgesArray()
    }).pipe(
      mergeMap(e => forkJoin([
          of(e),
          this._holidayPrefetchService.prefetchDeparturePlaces({
            onlyCustomHoliday: true,
            destination: e,
            ages: this._bookingService.getAgesArray()
          })
        ])
      ),
      mergeMap(e => {
          const holidayTypeList = ALL_HOLIDAY_TYPES; //getHolidayTypesByAirports(e[1]);
          return this._holidayPrefetchService.prefetchDate({
            destination: e[0],
            departurePlace: e[1],
            onlyCustomHoliday: true,
            holidayTypeList,
            onlyNetQuotes: false,
            ages: this._bookingService.getAgesArray()
          });
        }
      )
    ).subscribe(e => {
      const occupancyString = this._bookingService.getAgesString();
      const test = dayjs(e.map(x => dayjs(x, 'YYYY-MM-DD').toDate()).sort((a, b) => a > b ? 1 : -1).shift()).format('DD-MM-YYYY');
      const route = `/tour/ricerca/null/null/destinazione/tutte/aeroporto/tutti/il/${test}/eta/${occupancyString}`;
      this._loadingService.removeLoad(loadingItem);
      this._router.navigate([route], {
        queryParams: {
          proposte: true
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.prefetchSubscription?.unsubscribe();
  }

}
